"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const quickReplyTranslations = {
    quickReplyTitle: "Quick Reply",
    priorityLabel: "Priority Message On",
    manageTooltip: "Manage Quick Replies",
    emptyReplyListMessage: "No quick replies yet. Add your first one!",
    emptyReplyListHint: "Tap the edit button to add your first one!",
    addQuickReplyLabel: "Add a quick reply",
    addButton: "Add",
    addLimitError: "You can only add 10 replies. Delete one to add more",
    characterLimitError: "Quick reply cannot exceed 500 characters",
    fetchError: "Couldn't load your quick replies. Please try again.",
    addError: "Couldn't add the quick reply. Please try again.",
    deleteError: "Couldn't delete the quick reply. Please try again.",
    deleteDialogTitle: "Delete Quick Reply",
    deleteDialogMessage: "Are you sure you want to delete this quick reply?",
    deleteDialogConfirm: "Delete",
    deleteDialogCancel: "Cancel",
};
exports.default = quickReplyTranslations;
